<template>
  <v-dialog width="500" v-model="showTrailerTypeForm">
    <v-card>
      <v-card-title class="secondary white--text py-2 px-4">
        <span> {{ editMode ? "Update" : "Add" }} Trailer Type </span>

        <v-spacer />

        <v-btn icon @click="resetForm(), (showTrailerTypeForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-2">
        <v-form v-model="isValid" ref="trailerTypeForm">
          <v-row class="ma-0">
            <v-col cols="12" class="Form-Columns-Dense">
              <InputField
                label="Trailer Type *"
                :rules="[(v) => !!v || 'Trailer Type is Required']"
                required
                hide-details="auto"
                v-model="trailerTypeDetails.type_name"
                :error-messages="formErrors.type_name"
                @input="delete formErrors.type_name"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider/>

      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
  components: {
    InputField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editTrailerTypeID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getTrailerTypeObject(this.editTrailerTypeID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showTrailerTypeForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formErrors: {},
      isValid: true,

      trailerTypeDetails: {},
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.$api.trailerType
          .addTrailerType(this.trailerTypeDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Trailer Type added Successfully!",
              color: "success",
            });
            this.resetForm();
            this.showTrailerTypeForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add Trailer Type!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.trailerType
          .updateTrailerType({
            id: this.trailerTypeDetails.id,
            data: this.trailerTypeDetails,
          })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Trailer Type updated Successfully!",
              color: "success",
            });
            this.resetForm();
            this.showTrailerTypeForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update Trailer Type!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.trailerTypeForm) {
        this.$refs.trailerTypeForm.reset();
      }
      this.containerTypeDetails = {};
    },

    getTrailerTypeObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.trailerType
        .getTrailerTypeObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.trailerTypeDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>